import React from 'react';
import { useMediaAttachment } from '../../../hooks/useMediaAttachment';
import { MediaOverlay } from './MediaOverlay';
import { formatMessageTime } from '../../../utils/date.util';

type StickerAttachmentProps = {
    mediaId: string;
    createdAt: string;
    isSentByMe?: boolean;
};

export const StickerAttachment = ({ mediaId, createdAt, isSentByMe }: StickerAttachmentProps) => {
    const { url, status, downloadMedia } = useMediaAttachment(mediaId);

    return (
        <div className="position-relative" style={{ width: '150px', height: '150px' }}>
            <MediaOverlay status={status} typeLabel="Sticker" icon={<i className="ri-emotion-happy-line"></i>} onClick={downloadMedia} />
            {url && status === 'SUCCESS' && (
                <img src={url} alt="Sticker" className="w-100 h-100" style={{ objectFit: 'contain' }} loading="lazy" />
            )}
            <div
                className="position-absolute"
                style={{
                    bottom: '4px',
                    right: '4px',
                    zIndex: 2,
                    pointerEvents: 'none',
                }}
            >
                <div
                    className="rounded-pill d-flex align-items-center text-white"
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.45)',
                        padding: '2px 6px',
                        fontSize: '11px',
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                    }}
                >
                    <span>{formatMessageTime(createdAt)}</span>
                    {isSentByMe && (
                        <i className="ri-check-double-line ms-1 text-white" style={{ fontSize: '13px' }}></i>
                    )}
                </div>
            </div>
        </div>
    );
};
